import { CloseIcon } from '@chakra-ui/icons'
import {
  Box,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  Flex,
  IconButton,
  Img,
  Text,
} from '@chakra-ui/react'
import { colors } from '@hb/shared'
import { useEffect } from 'react'
import { useProfile } from '../../../../../../contexts/user/ProfileContext'
import { useProfileLayout } from '../../../../../../contexts/user/ProfileLayoutContext'
import pinIcon from '../../../../../../icons/pin.svg'
import { PatientInfo } from './PatientInfo'

export const PatientInfoDrawer = () => {
  const { layoutMode, sidebar } = useProfileLayout()
  const { isOpen, onClose, canPin, setPinned } = sidebar
  const { tab, subTab } = useProfile()
  const tabPath = tab?.path
  const subTabPath = subTab?.path
  // close the drawer when navigation happens inside it (eg tapping the consent forms link)
  useEffect(() => {
    onClose()
  }, [tabPath, subTabPath, onClose])
  return (
    <Drawer autoFocus={false} isOpen={isOpen} placement="left" onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent maxW={layoutMode === 'mobile' ? '88%' : '340px'}>
        <Flex align="center" gap={1} px={2} h="40px" flexShrink={0} bg={colors.pink.hex}>
          <Text
            fontFamily="Hero-New"
            fontWeight={500}
            color="white"
            textShadow="1px 1px 3px #00000077">
            Patient
          </Text>
          <Box flex={1} />
          {canPin ? (
            <IconButton
              aria-label="Pin patient panel open"
              size="sm"
              variant="ghost"
              _hover={{ bg: 'whiteAlpha.300' }}
              icon={<Img src={pinIcon} h="16px" filter="brightness(0) invert(1)" />}
              onClick={() => {
                setPinned(true)
                onClose()
              }}
            />
          ) : null}
          <IconButton
            aria-label="Close patient details"
            size="sm"
            variant="ghost"
            _hover={{ bg: 'whiteAlpha.300' }}
            icon={<CloseIcon w={3} h={3} color="white" />}
            onClick={onClose}
          />
        </Flex>
        <Box flex={1} minH={0} overflow="hidden">
          <PatientInfo />
        </Box>
      </DrawerContent>
    </Drawer>
  )
}
